import { useMutation, useQueryClient } from '@tanstack/react-query';
import { districtApi } from '../api/district.api';
import { districtKeys } from '../api/district.keys';
import toast from 'react-hot-toast';
import type { AxiosError } from 'axios';
import type { ApiErrorResponse, DistrictFormData } from '@/shared/types';

export function useCreateDistrict() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: DistrictFormData) => districtApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: districtKeys.all });
      toast.success('District created');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to create');
    },
  });
}

export function useUpdateDistrict() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: DistrictFormData }) =>
      districtApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: districtKeys.all });
      toast.success('District updated');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to update');
    },
  });
}

export function useDeleteDistrict() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => districtApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: districtKeys.all });
      toast.success('District deleted');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to delete');
    },
  });
}
